import 'babel-polyfill';

// configure webpack where to look for assets
import './set-public-path';

import './client';



// WEBPACK FOOTER //
// ./src/client-entry.js